import '../styles/ExternalLink.scss';
import { ReactChild, ReactFragment, ReactPortal } from "react";
import { MdLaunch } from "react-icons/md";

export default function ExternalLink(props: { href: string; children: ReactChild | ReactFragment | ReactPortal; }){
    return <a className="external" href={props.href} target="_blank" rel="noopener noreferrer">{props.children} <MdLaunch size={20}/></a>
}